export default {
    previousPage:null
}